// 仅用于显示使用，如果需要修改，则深拷贝后修改
// 班期
export const scheduleOptions = [
    { id: "1", name: "周一", value: '0000001', },
    { id: "2", name: "周二", value: '0000010' },
    { id: "3", name: "周三", value: '0000100' },
    { id: "4", name: "周四", value: '0001000' },
    { id: "5", name: "周五", value: '0010000' },
    { id: "6", name: "周六", value: '0100000' },
    { id: "7", name: "周日", value: '1000000' },

]
// 报价单箱型列表
export const quotationContainerTypeList = [

    { id: 1, name: "20GP" },
    { id: 2, name: "40GP" },
    { id: 3, name: "40HQ" },
    { id: 4, name: "45HQ" },
    { id: 5, name: "40NOR" },
    { id: 6, name: "20OT" },
    { id: 7, name: "40OT" },
    { id: 8, name: "20FR" },
    { id: 9, name: "40FR" },
    { id: 10, name: "20BO" },
    { id: 11, name: "40BO" },
    { id: 12, name: "20RF" },
    { id: 13, name: "40RF" },
    { id: 14, name: "20BK" },
    { id: 15, name: "40BK" },
    { id: 16, name: "20TK" },
    { id: 17, name: "40TK" },
    { id: 18, name: "12GP" },
    { id: 19, name: "20HQ" },
    { id: 20, name: "20HT" },
    { id: 21, name: "40HT" },
    { id: 22, name: "20RH" },
    { id: 23, name: "40RH" },
]

// 计费单位列表

export const chargeUnitOptions = [
    { id: 0, name: '票' },
    { id: 1, name: "20GP" },
    { id: 2, name: "40GP" },
    { id: 3, name: "40HQ" },
    { id: 4, name: "45HQ" },
    { id: 5, name: "40NOR" },
    { id: 6, name: "20OT" },
    { id: 7, name: "40OT" },
    { id: 8, name: "20FR" },
    { id: 9, name: "40FR" },
    { id: 10, name: "20BO" },
    { id: 11, name: "40BO" },
    { id: 12, name: "20RF" },
    { id: 13, name: "40RF" },
    { id: 14, name: "20BK" },
    { id: 15, name: "40BK" },
    { id: 16, name: "20TK" },
    { id: 17, name: "40TK" },
    { id: 18, name: "12GP" },
    { id: 19, name: "20HQ" },
    { id: 20, name: "20HT" },
    { id: 21, name: "40HT" },
    { id: 22, name: "20RH" },
    { id: 23, name: "40RH" },
]
// 服务类型
export const serviceOptions = [
    {
        id: "1",
        name: "订舱费",
        typeName: '订舱'
    },
    {
        id: "2",
        name: "拖车费",
        typeName: '拖车'
    },
    {
        id: "3",
        name: "报关费",
        typeName: '报关'
    },
    {
        id: "4",
        name: "海外段",
        typeName: '海外段'
    },
]
// 集装箱尺寸详情
export const containerSizeList = [
    {
        id: 1,
        img: require('@/images/holdAll/container-1.png'),
        name: '20尺标箱',
        sizeStr: '20´ x 8´ x 8´6˝',
        temperature: '',
        inner: {
            l: '5,898 mm',
            w: '2,350 mm',
            h: '2,392 mm'
        },
        door: {
            w: '2,340 mm',
            h: '2,292 mm'
        },
        grossWeight: '2,230 kgs',
        loadWeight: '28,230 kgs',
        volume: '28 cbm'
    },

    {
        id: 2,
        img: require('@/images/holdAll/container-2.png'),
        name: '40尺标箱',
        sizeStr: '40´ x 8´ x 8´6˝',
        temperature: '',
        inner: {
            l: '12,029 mm',
            w: '2,350 mm',
            h: '2,392 mm'
        },
        door: {
            w: '2,340 mm',
            h: '2,292 mm'
        },
        grossWeight: '3,780 kgs',
        loadWeight: '26,700 kgs',
        volume: '58 cbm'
    },

    {
        id: 3,
        img: require('@/images/holdAll/container-3.png'),
        name: '40尺高箱',
        sizeStr: '40´ x 8´ x 9´6˝',
        temperature: '',
        inner: {
            l: '12,029 mm',
            w: '2,350 mm',
            h: '2,697 mm'
        },
        door: {
            w: '2,340 mm',
            h: '2,597 mm'
        },
        grossWeight: '4,020 kgs',
        loadWeight: '26,460 kgs',
        volume: '68 cbm'
    },

    {
        id: 4,
        img: require('@/images/holdAll/container-45.png'),
        name: '45尺高箱',
        sizeStr: '45´ x 8´ x 9´6˝',
        temperature: '',
        inner: {
            l: '13,556 mm',
            w: '2,352 mm',
            h: '2,700 mm'
        },
        door: {
            w: '2,340 mm',
            h: '2,597 mm'
        },
        grossWeight: '4,800 kgs',
        loadWeight: '27,700 kgs',
        volume: '86 cbm'
    },

    {
        id: 5,
        img: require('@/images/holdAll/container-4.png'),
        name: '20尺开顶箱',
        sizeStr: '20´ x 8´ x 8´6˝',
        temperature: '',
        inner: {
            l: '5,888 mm',
            w: '2,345 mm',
            h: '2,315 mm'
        },
        door: {
            w: '2,286 mm',
            h: '2,184 mm'
        },
        grossWeight: '2,250 kgs',
        loadWeight: '30,480 kgs',
        volume: '32 cbm'
    },

    {
        id: 6,
        img: require('@/images/holdAll/container-5.png'),
        name: '40尺开顶箱',
        sizeStr: '40´ x 8´ x 8´6˝',
        temperature: '',
        inner: {
            l: '12,029 mm',
            w: '2,342 mm',
            h: '2,326 mm'
        },
        door: {
            w: '2,274 mm',
            h: '2,230 mm'
        },
        grossWeight: '3,810 kgs',
        loadWeight: '26,670 kgs',
        volume: '65 cbm'
    },

    {
        id: 7,
        img: require('@/images/holdAll/container-6.png'),
        name: '20尺框架箱',
        sizeStr: '20´ x 8´ x 8´6˝',
        temperature: '',
        inner: {
            l: '5,698 mm',
            w: '2,230 mm',
            h: '2,255 mm'
        },
        door: {
            w: '',
            h: ''
        },
        grossWeight: '2,500 kgs',
        loadWeight: '21,500 kgs',
        volume: ''
    },

    {
        id: 8,
        img: require('@/images/holdAll/container-7.png'),
        name: '40尺框架箱',
        sizeStr: '40´ x 8´ x 8´6˝',
        temperature: '',
        inner: {
            l: '11,832 mm',
            w: '2,228 mm',
            h: '1,981 mm'
        },
        door: {
            w: '',
            h: ''
        },
        grossWeight: '4,200 kgs',
        loadWeight: '40,800 kgs',
        volume: ''
    },

    {
        id: 9,
        img: require('@/images/holdAll/container-8.png'),
        name: '20尺可折叠框架箱',
        sizeStr: '20´ x 8´ x 8´6˝',
        temperature: '',
        inner: {
            l: '5,675 mm',
            w: '2,213 mm',
            h: '2,270 mm'
        },
        door: {
            w: '',
            h: ''
        },
        grossWeight: '2,600 kgs',
        loadWeight: '30,150 kgs',
        volume: ''
    },

    {
        id: 10,
        img: require('@/images/holdAll/container-9.png'),
        name: '40尺可折叠框架箱',
        sizeStr: '40´ x 8´ x 8´6˝',
        temperature: '',
        inner: {
            l: '11,660 mm',
            w: '2,200 mm',
            h: '2,245 mm'
        },
        door: {
            w: '',
            h: ''
        },
        grossWeight: '5,700 kgs',
        loadWeight: '39,300 kgs',
        volume: ''
    },

    {
        id: 11,
        img: require('@/images/holdAll/container-10.png'),
        name: '20尺平板箱',
        sizeStr: '20´ x 8´ x 8´6˝',
        temperature: '',
        inner: {
            l: '6,058 mm',
            w: '2,438 mm',
            h: '370 mm'
        },
        door: {
            w: '',
            h: ''
        },
        grossWeight: '2,520 kgs',
        loadWeight: '27,960 kgs',
        volume: ''
    },

    {
        id: 12,
        img: require('@/images/holdAll/container-11.png'),
        name: '40尺平板箱',
        sizeStr: '40´ x 8´ x 8´6˝',
        temperature: '',
        inner: {
            l: '12,192 mm',
            w: '2,245 mm',
            h: '648 mm'
        },
        door: {
            w: '',
            h: ''
        },
        grossWeight: '5,700 kgs',
        loadWeight: '39,300 kgs',
        volume: ''
    },

    {
        id: 13,
        img: require('@/images/holdAll/container-12.png'),
        name: '20尺冷冻箱',
        sizeStr: '20´x 8´x 8´6˝',
        temperature: 'Temp +30˚C to -30˚C',
        inner: {
            l: '5,724 mm',
            w: '2,286 mm',
            h: '2,014 mm'
        },
        door: {
            w: '2,286 mm',
            h: '2,067 mm'
        },
        grossWeight: '2,550 kgs',
        loadWeight: '21,450 kgs',
        volume: '26 cbm'
    },

    {
        id: 14,
        img: require('@/images/holdAll/container-13.png'),
        name: '40尺冷冻箱',
        sizeStr: '20´x 8´x 9´6˝',
        temperature: 'Temp +30˚C to -30˚C',
        inner: {
            l: '11,840 mm',
            w: '2,286 mm',
            h: '2,120 mm'
        },
        door: {
            w: '2,286 mm',
            h: '2,195 mm'
        },
        grossWeight: '3,850 kgs',
        loadWeight: '26,630 kgs',
        volume: '60 cbm'
    },

    {
        id: 15,
        img: require('@/images/holdAll/container-14.png'),
        name: '20尺散装箱',
        sizeStr: '20´ x 8´ x 8´6˝',
        temperature: '',
        inner: {
            l: '5,934 mm',
            w: '2,358 mm',
            h: '2,340 mm'
        },
        door: {
            w: '2,335 mm',
            h: '2,292 mm'
        },
        grossWeight: '2,450 kgs',
        loadWeight: '21,550 kgs',
        volume: '32 cbm'
    },

    {
        id: 16,
        img: require('@/images/holdAll/container-15.png'),
        name: '20尺罐装箱',
        sizeStr: '',
        temperature: '',
        inner: {
            l: '6,058 mm',
            w: '2,438 mm',
            h: '2,438 mm'
        },
        door: {
            w: '',
            h: ''
        },
        grossWeight: '4,190 kgs',
        loadWeight: '26,290 kgs',
        volume: ''
    },



]


